<itl-channel-list-message
  [header]="'chat.channelList.offlineMessage.header' | translate"
  [message]="'chat.channelList.offlineMessage.message' | translate"
  icon="alberta-chat-channel-list-offline"
  *ngIf="!isChatOnline"
></itl-channel-list-message>
<ng-content></ng-content>
